// import { CognitoUserPool } from 'amazon-cognito-identity-js';
// import Env from '../runtimeEnv';

// const poolData = {
    
//     UserPoolId: Env.REACT_APP_COGNITO_USER_POOL_ID, // Fetching from environment variable
//     ClientId: Env.REACT_APP_COGNITO_CLIENT_ID,      // Fetching from environment variable
// };

// export const userPool = new CognitoUserPool(poolData);


import { CognitoUserPool } from "amazon-cognito-identity-js";
import Env from "../runtimeEnv";

const localDemo =
  Env.REACT_APP_ENABLE_DEMO_MODE === "true" &&
  ["localhost", "127.0.0.1"].includes(window.location.hostname);

const poolData = {
  // Cognito's constructor validates eagerly, even though demo login never calls it.
  UserPoolId: Env.REACT_APP_COGNITO_USER_POOL_ID || (localDemo ? "us-east-1_localdemo" : ""),
  ClientId: Env.REACT_APP_COGNITO_CLIENT_ID || (localDemo ? "localdemoclient" : ""),
};

if (!poolData.UserPoolId || !poolData.ClientId) {
  console.error("❌ Missing Cognito config!");
  throw new Error(
    "Both UserPoolId and ClientId are required. Check .env or runtime env setup."
  );
}

export const userPool = new CognitoUserPool(poolData);
